import Swiper from 'swiper/bundle';

const buildSwiperSlider = sliderElm => {
    const sliderIdentifier = sliderElm.dataset.id;
    return new Swiper(`#${sliderElm.id}`, {
        spaceBetween: 16,
        slidesPerView: "auto",
        loop: false,
        updateOnWindowResize: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideFullyVisibleClass: 'swiper-slide-fully-visible',
        navigation: {
            nextEl: `.section-reviews-slider-swiper-button-next-${sliderIdentifier}`,
            prevEl: `.section-reviews-slider-swiper-button-prev-${sliderIdentifier}`
        },
        pagination: {
            el: `.swiper-pagination-${sliderIdentifier}`,
            clickable: true,
        },
    });
}

const allSliders = $('.section-reviews-slider');

allSliders.each((index, element) => buildSwiperSlider(element));